const LightTheme = {
  components: {
    Select: {
      borderRadiusSM: 0,
      optionActiveBg: "transparent",
      optionSelectedBg: "rgba(244, 244, 244, 1)",
    },
    Switch: {
      handleSize: 18,
      trackMinWidth: 36,
      colorTextQuaternary: "rgba(152, 152, 152, 1)",
    },
  },
  token: {
    fontFamily: `"Inter", serif`,
    colorPrimary: "rgba(218, 31, 31, 1)",
    divider: "rgba(0, 0, 0, 0.2)",
    success: "rgba(97,184,146,1)",
    colorTextPlaceholder: "rgba(118, 118, 118, 1)",
    colorSplit: "rgba(191, 190, 190, 1)",
    fontColors: {
      primary: "rgba(218, 31, 31, 1)",
      secondary: "rgba(0, 0 , 0, 1)",
      tertiary: "rgba(255, 255 , 255, 1)",
      destructive: "rgba(218, 31, 31, 1)",
      success: "rgba(97,184,146,1)",
      gray: "rgba(0, 0, 0, 0.6)",
      disabled: "rgba(152, 152, 152, 1)",
      disabledDark: "rgba(112, 112, 112, 1)",
    },
    surface: {
      primary: "rgba(244, 244, 244, 1)",
    },
    actions: {
      primary: "rgba(218, 31, 31, 1)",
      success: "rgba(97,184,146,1)",
      secondary: "rgba(0, 0 , 0, 1)",
      tertiary: "rgba(255, 255 , 255, 1)",
      disable: "rgba(164, 164, 164, 1)",
    },
    alerts: {
      error: {
        message: "rgba(218, 31, 31, 1)",
        border: "rgba(255, 207, 207, 1)",
        background: "rgba(255, 228, 228, 1)",
      },
    },
  },
  colors: {
    background: "rgba(243, 243, 243, 1)",
    surface: {
      primary: "rgba(255, 255 , 255, 1)",
    },
    font: {
      primary: "#174B5F",
      secondary: "rgba(0, 0 , 0, 1)",
      tertiary: "rgba(255, 255 , 255, 1)",
    },
  },
  shadow: {
    box19: `box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;`,
    box33: `box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;`,
    box29: `box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;`,
  },
};

export { LightTheme };
